export default {
  cloudCannonContent: (state) => state.cloudCannonContent,
  cloudCannonContentLoading: (state) => state.cloudCannonContentLoading,
  cloudCannonFooterContent: (state) => state.cloudCannonFooterContent,
  cloudCannonFooterContentLoading: (state) => state.cloudCannonFooterContentLoading,
}
